import * as XLSX from "xlsx";
import {saveWorkbook} from "../../../utils/excel";
import {filterPostsByCategory} from "../../../utils/category";

const HEADER = ['大分類', '文章則數']

export const useExportContentCategories = ({
  posts, categories,
}) => {
  // export cases detail to excel file
  const exportData = () => {
    const workbook = XLSX.utils.book_new();
    const values = []

    if (categories?.[0]?.children?.length > 0) {
      values.push(HEADER)
      for (const category of categories?.[0]?.children) {
        const filteredPost = filterPostsByCategory(posts, category);
        values.push([
          category.name,
          filteredPost.length
        ])
      }
    }

    const worksheet = XLSX.utils.aoa_to_sheet(values);
    XLSX.utils.book_append_sheet(workbook, worksheet, '總表');
    saveWorkbook({ workbook, fileName: '衛教資訊數據報表'})
  }
  return { exportData }
}
